import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { Routes, Route, Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import Funds from "components/charts/FundsTable";
import Margin from "components/charts/Margin";
import DematHoldings from "components/charts/DematHoldings";
import PortfolioHoldings from "components/charts/PortfolioHoldings";
import PortfolioPositions from "components/charts/PortfolioPositions";
import Dashboard from "pages/Dashboard";
import Orders from "components/charts/Orders";
import ApiKeyGenerator from "components/charts/ApiKeyGenerator";
import StrategyConfiguration from "components/charts/StrategyConfiguration";
import SessionTokenComponent from "components/charts/SessionTokenComponent";
import MarginTable from "components/charts/MarginTable";
import GlobalIndices from "components/charts/GlobalIndices";
import IndianIndices from "components/charts/IndianIndices";
import ADR from "components/charts/ADR";
import Commodity from "components/charts/Commodity";
import GlobalCurrency from "components/charts/GlobalCurrency";
import Nifty50 from "components/charts/Nifty50";
import BankNifty from "components/charts/BankNifty";
import FinNifty from "components/charts/FinNifty";
import MidCapSelect from "components/charts/MidCapSelect";
import Sensex from "components/charts/Sensex";
import BankEx from "components/charts/BankEx";
import TickerTape from "components/charts/TickerTape";



const Container = styled.div`
  ${tw`bg-gray-100 h-screen w-screen overflow-hidden flex`}
`;

const MainContent = styled.div`
  ${tw`flex flex-col flex-1 overflow-hidden`}
`;

const Content = styled.div`
  ${tw`flex-1 p-4  overflow-auto`}
`;


const Content1 = styled.div`
  ${tw`mb-6  overflow-hidden`}
`;

export default function Layout() {
  return (
    <Container>
      <Sidebar />
      <MainContent>
        
        <Header />

        <Content>
        <Content1>
        <TickerTape/>
        </Content1>
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/apikeygenerator" element={<ApiKeyGenerator />} />
            <Route path="/stra" element={<StrategyConfiguration />} />
            <Route path="/session-token" element={<SessionTokenComponent />} />
            <Route path="accounts/funds" element={<Funds />} />
            <Route path="accounts/margin" element={<Margin />} />
            <Route path="/global-indices" element={<GlobalIndices/>} />
              <Route path="/indian-indices" element={<IndianIndices />} />
              <Route path="/commodity" element={<Commodity />} />
              <Route path="/indian-adr" element={<ADR />} />
              <Route path="/global-currency" element={<GlobalCurrency />} />
              <Route path="/nifty-50" element={<Nifty50 />} />
              <Route path="/bank-nifty" element={<BankNifty/>} />
              <Route path="/fin-nifty" element={<FinNifty />} />
              <Route path="/midcap-select" element={<MidCapSelect />} />
              <Route path="/sensex" element={<Sensex />} />
              <Route path="/bankex" element={<BankEx />} />
            <Route path="accounts/demat-holdings" element={<DematHoldings />} />
            <Route path="accounts/portfolio-holdings" element={<PortfolioHoldings />} />
            <Route path="accounts/portfolio-positions" element={<PortfolioPositions />} />
            {/* Add routes for other components here */}
          </Routes>
          <Outlet />
        </Content>
      </MainContent>
    </Container>
  );
}
